import { RestModels } from "tradehub-api-js";

export const sortOrder = (lhs: RestModels.Order, rhs: RestModels.Order) => {
  return parseInt(rhs.id) - parseInt(lhs.id);
}
